var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',{attrs:{"list":_vm.colonnes,"handle":".move-action","group":'colonneList'+_vm.conindex},on:{"change":_vm.handleDrag}},_vm._l((_vm.colonnes),function(el,colindex){return _c('colonne',{key:'colonne-'+colindex,attrs:{"col-data":el,"col-index":colindex,"con-index":_vm.conindex}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74076314","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheEspace/edit/listColonne.vue
// module id = null
// module chunks = 